import React from 'react';
import ComboBox from '@react/react-spectrum/ComboBox';
import '../../style.css';

export default class ComboBoxComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  pageRedirect(obj) {
    if (obj.value) {
      window.location.href = obj.value;
    }
  }

  render() {
    return (
      <ComboBox
        size={2}
        placeholder="Search for an Adobe product"
        options={this.props.products}
        onSelect={evt => this.pageRedirect(evt)}
      />
    );
  }
}
